import nextBtn from "../../assets/login/nextBtn.svg";

export default function AuthBtn({ clickFunction }) {
  return (
    <div
      onClick={clickFunction}
      className="absolute bottom-5 right-[10px] rounded-full"
    >
      <img src={nextBtn} alt="" />
    </div>
  );
}
